import type { Offer } from '@fourthwall/services/dist/models/offer'
import { DIGITAL_PRODUCTS_FEE_PERCENTAGE } from '@fourthwall/utils/dist/constants'
import { formatCurrency } from '@fourthwall/utils/dist/currency'

import type { OfferType } from '../../SingleProduct.types'

export const calculateProfit = (
  variants: Offer.Variant[],
  offerType: OfferType,
  digitalProductsFeePercentage = DIGITAL_PRODUCTS_FEE_PERCENTAGE,
) => {
  const cost = variants[0].cost?.value
  const price = variants[0].price.value

  if (!cost && offerType === 'DIGITAL') {
    return Number(formatCurrency(((100 - digitalProductsFeePercentage) / 100) * price))
  }

  return price - (cost || 0)
}
